export default "__VITE_ASSET__93b62374__"